import { isPlainObject } from 'lodash';

/**
 * Validate that the settings structure is valid but allows partial data (for merge mode)
 *
 * @param {object} data - Parsed settings data
 * @returns {object} { isValid: boolean, errors: string[] }
 */
export default function validateSettingsPartial(data) {
  const errors = [];

  if (!isPlainObject(data)) {
    errors.push('Invalid file format: Expected an object');
    return { isValid: false, errors };
  }

  if (data.syncInjectorSettings && !isPlainObject(data.syncInjectorSettings)) {
    errors.push('Invalid syncInjectorSettings: Expected an object');
  }

  if (data.integrations && !Array.isArray(data.integrations)) {
    errors.push('Invalid integrations: Expected an array');
  }

  return {
    isValid: errors.length === 0,
    errors,
  };
}
